<div class="mr-button-row">
  <button
    type="button"
    class="mr-button"
    [attr.data-variant]="block.variant || 'primary'"
    (click)="onClick()"
  >
    {{ t(block.label) }}
  </button>
</div>
